import React, { useEffect, useState } from "react";
import { Dropdown } from "primereact/dropdown";
import { Icon } from "@vds/icons";
import "./CustomDropdownWithHeaders.css";
import { postApplyActions } from "../../../services/C4S Decommission - Replacement/viewVehicleListByAddress";

const CustomDropdownWithHeaders = ({ setSelectedAction, selectedAction, notify, actionListPayload }) => {
  const [dropdownOptions, setDropdownOptions] = useState([]);
  const [isLoading, setIsLoading] = useState(false);
  // Stringify payload to use as a stable dependency for the effect
  const payloadKey = JSON.stringify(actionListPayload);

  useEffect(() => {
    const fetchActionList = async () => {
      if (!actionListPayload) return;
      setIsLoading(true);
      try {
        const response = await postApplyActions(actionListPayload);
        if (response?.status === 200 && response?.data?.data?.supportedActions && Array.isArray(response.data.data.supportedActions)) {
          setDropdownOptions(response.data.data.supportedActions);
        } else {
          if (notify) notify("Failed to fetch action list", "error");
          setDropdownOptions([]);
        }
      } catch (err) {
        if (notify) notify("Failed to fetch action list", "error");
        setDropdownOptions([]);
      } finally {
        setIsLoading(false);
      }
    };
    fetchActionList();
  }, [payloadKey]);

  const customItemTemplate = (option) => {
    if (option.items) {
      // Render group header
      return (
        <div
          style={{
            fontSize: "14px",
            fontWeight: "bold",
            color: "#000",
            cursor: "default",
          }}
        >
          {option.label}
        </div>
      );
    }
    // Render regular option
    const isDelete = option.label && option.label.toLowerCase().includes("delete");
    return (
      <div
        style={{
          display: "flex",
          alignItems: "center",
          gap: "8px",
          cursor: "pointer",
          fontSize: "14px",
        }}
      >
        {isDelete && <Icon name="trash" size="small" color="#cc0000" />}
        <span style={{ color: isDelete ? "#cc0000" : "#000" }}>{option.label}</span>
      </div>
    );
  };
  const flattenOptions = (groups) => {
    const flattened = [];
    groups.forEach((group) => {
      if (group.label) {
        flattened.push({ label: group.label, items: group.items });
      }
      (group.items || []).forEach((item) => {
        flattened.push(item);
      });
    });
    return flattened;
  };

  const flattenedOptions = flattenOptions(dropdownOptions);

  return (
    <div>
      <Dropdown
        value={selectedAction?.value || selectedAction}
        options={flattenedOptions}
        onChange={(e) => {
          // Find the full option object from the flattened list and pass it upstream
          const selectedOption = flattenedOptions.find((opt) => !opt.items && opt.value === e.value);
          setSelectedAction(selectedOption || e.value);
        }}
        optionLabel="label"
        optionValue="value"
        itemTemplate={customItemTemplate}
        placeholder={isLoading ? "Loading..." : "Select action"}
        disabled={isLoading || !!selectedAction?.value || (typeof selectedAction === "string" && !!selectedAction)}
        style={{
          width: "280px",
          height: "44px",
          marginLeft: "26px",
          fontFamily: "Verizon-NHG-eDS",
          fontSize: "16px",
          fontWeight: 400,
          lineHeight: "20px",
          letterSpacing: "0.5px",
        }}
      />
    </div>
  );
};

export default CustomDropdownWithHeaders;
